/** Supporter Ideas administration console (Cloudflare Access + admin Worker). */
export const ADMIN_APP_ORIGIN = "https://admin.worthyidea.net";

export function adminAppUrl(path = "/"): string {
	const normalized = path.startsWith("/") ? path : `/${path}`;
	return `${ADMIN_APP_ORIGIN}${normalized}`;
}
